import { render, staticRenderFns } from "./ShoppableSettings.vue?vue&type=template&id=bf05bc78"
import script from "./ShoppableSettings.vue?vue&type=script&lang=js"
export * from "./ShoppableSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports